import type { ReactNode } from "react";
import "./app-footer.css";

type AppFooterProps = {
  children?: ReactNode;
  showCopyright?: boolean;
  startYear?: number;
};

const resolveCopyrightYears = (startYear: number): string => {
  const currentYear = new Date().getFullYear();
  return currentYear > startYear ? `${startYear}-${currentYear}` : `${startYear}`;
};

export const AppFooter = ({ children, showCopyright = true, startYear = 2026 }: AppFooterProps) => {
  const years = resolveCopyrightYears(startYear);

  return (
    <footer className="app-footer">
      <div className="app-footer-brand">
        <span
          aria-hidden="true"
          className="app-footer-logo"
        />
        <p className="app-footer-tagline">Made for your information.</p>
      </div>

      {children ? <div className="app-footer-links">{children}</div> : null}

      {showCopyright ? <p className="app-footer-copyright">© Copyright {years}, BlueLink Consultancy Kft.</p> : null}
    </footer>
  );
};
